<template>
    <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        width="40.000000" height="40.000000" fill="none">
        <rect id="svg" width="40.000000" height="40.000000" x="0.000000" y="0.000000" />
        <rect id="4882" width="33.333332" height="23.333332" x="3.333008" y="5.000000" rx="2.000000"
            stroke="rgb(80,200,120)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.000000" />
        <line id="4883" x1="13.3330078" x2="26.6663399" y1="35" y2="35" stroke="rgb(80,200,120)" stroke-linecap="round"
            stroke-linejoin="round" stroke-width="2.000000" />
        <line id="4884" x1="0" x2="6.66666794" y1="0" y2="0" stroke="rgb(80,200,120)" stroke-linecap="round"
            stroke-linejoin="round" stroke-width="2.000000" transform="matrix(0,1,-1,0,20,28.3333)" />
    </svg>
</template>